import React from 'react'

const MobViewDetailCard = () => {
  return (
    <div className="tb_movView_card_container">
      <div className="tb_mobView_card_md">
        <div className="tb_mv_card">
          <div className="tb_card_row">
            <div className="tb_MV_info_left">
              <p className="tb_info_head">From</p>
              <p className="tb_card_details">Dubai (DUX)</p>
            </div>
            <div className="tb_MV_info">
              <p className="tb_info_head">To</p>
              <p className="tb_card_details">Los Angleses (LA)</p>
            </div>
          </div>
          <div className="tb_card_row">
            <div className="tb_MV_info_left">
              <p className="tb_info_head">TRAVEL MODE</p>
              <p className="tb_card_details">RAIL</p>
            </div>
            <div className="tb_MV_info">
              <p className="tb_info_head">OPERATOR</p>
              <p className="tb_card_details">Hawaiian Airlines</p>
            </div>
          </div>
          <div className="tb_card_row">
            <div className="tb_MV_info_left">
              <p className="tb_info_head">TRAVEL DATE</p>
              <p className="tb_card_details">21/01/21</p>
            </div>
            <div className="tb_MV_info">
              <p className="tb_info_head">STATUS</p>
              <p className="tb_card_details">NOW</p>
            </div>
            <div className="tb_MV_info">
              <p className="tb_info_head">DIST. TYPE</p>
              <p className="tb_card_details">Cancelled</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobViewDetailCard
